module.exports = __webpack_public_path__ + "static/img/img-educator-feature-3@2x.6dea4bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-3@2x.png
// module id = iOoc
// module chunks = 18